export default "__VITE_ASSET__0bb05e10__"